const groupPrefix = 'maps'

export const apiGeocoding = {
	autocompleteRequest: async (input: string, lang = 'pl') => {
		const { data } = await apiCommon<any>(
			`${groupPrefix}/autocomplete`,
			{
				method: 'GET',
				query: { input },
			},
			lang,
		)
		return data
	},

	getPlaceDetails: async (placeID: string, lang = 'pl') => {
		const { data } = await apiCommon<any>(
			`${groupPrefix}/place/${placeID}`,
			{
				method: 'GET',
			},
			lang,
		)
		return data
	},

	decodeCoordinates: async (lat: number, lng: number, lang = 'pl') => {
		const { data } = await apiCommon<any>(
			`${groupPrefix}/geocode/reverse`,
			{
				method: 'GET',
				query: { lat, lng },
			},
			lang,
		)
		return data
	},
}
